import React, { useEffect, useState } from "react";
import ReportOptions from "../ReportOptions";
import { Button } from "bootstrap";
import { useNavigate } from "react-router-dom";
import { proxy } from '../../process/api';
import DynamicDTFloatTabs from "../DynamicDTFloatTabs";
import DynamicDTFloat from "../DynamicDTFloat";
import DropDownControl from "../DropDownControl";
import BrandedLoader from "../BrandedLoader";
import { hst03_report_json_format, generateExcel, getHeaderColNames, excelColorCodes, transformNavDataForLabels, goFullScreen } from "../../utils";
import MultiSelectOptions from "./../MultiSelectOptions";
import MultiSheetProcessingLoader from "../MultiSheetProcessingLoader";
import ButtonLoader from "../ButtonLoader";
import ProcessLoader from "../ProcessLoader";

import configData from "../../config.json";


const ST02 = () => {


    const navigate = useNavigate();

    const div_data = JSON.parse(localStorage.getItem('div_data'));
    const year_data = JSON.parse(localStorage.getItem('year_data'));
    const month_data = JSON.parse(localStorage.getItem('month_data'));
    const depo_data = JSON.parse(localStorage.getItem('depo_data'));
    const allIndiaTypeDepo = depo_data.data.filter(item => item.value != "0"); //removed 0 from all type users

   
    const seleted_div_value = localStorage.getItem('selected_div');
    const [showOptions, setShowOptions] = useState(true);
    const [tabLoader, setTabLoader] = useState([]); //add product codes
    const [reportGenData, setreportGenData] = useState({});
    const [SelectedDiv, setSelectedDIV] = useState(seleted_div_value);
    const [SelectedYear, setSelectedYear] = useState(year_data.data[0].value);
    const [SelectedDepo, setSelectedDepo] = useState(allIndiaTypeDepo[0].value);
    const [SelectedStartMonth, setSelectedStartMonth] = useState(month_data.data[0].value);
    const [SelectedEndMonth, setSelectedEndMonth] = useState(month_data.data[month_data.index - 1].value);
    const [StockistListItems, setStockistListItems] = useState([]);
    const [productlistLoading, setProductlistLoading] = useState(true);
    const [SelectedProductCodes, setSelectedProductCodes] = useState([])
    const [productReportData, setProductReportdata] = useState([]);
    const [unitValue, setUnitValue] = useState(1);
    const [ReportType, setReportType] = useState(1);
    const [showReportLoader, setShowReportLoader] = useState(false);
    const [showProcessLoader, setShowProcessLoader] = useState(false);
    const [pageTitle, setPageTitle] = useState('');
    const [reportGenerationCompleted, setReportGenerationCompleted] = useState(false);
    const [reportDataReady, setReportDataReady] = useState(false);
    const [MultiSheetDownloadStart, setMultiSheetDownloadStart] = useState(false);
    const [creditNoteType, setCreditNoteType] = useState(0);
    const [optType, setOptType] = useState(1);
    const [showHQLoading, setHQLoading] = useState(false);
    const [GroupwiseProductWiseOpt, setGroupwiseProductWiseOpt] = useState(1);
    const [SelectedHQ, setSelectedHQ] = useState(0);
    const [HQvalues, setHQValues] = useState({ data: [] });

    useEffect(() => {

        if (reportGenerationCompleted) {
            setReportDataReady(true);
        }
    }, [reportGenerationCompleted]);


    useEffect(() => {
        if (reportDataReady) {

            var reportJson = {};
            var multiReportTitle = [];
            reportJson.fileName = "Selective Stockiest Product Wise Gross/Credit/Net Trend-" + SelectedYear + ".xlsx";
            reportJson.title = "Selective Stockiest Product Wise Gross/Credit/Net Trend";
            reportJson.author = "Aristo Pharma";


            reportJson.sheets = [];
            productReportData.map((singlereport, index) => {


                reportJson.sheets.push({
                    name: SelectedProductCodes[index].value.toString().trim(),
                    data: []
                })

                multiReportTitle.push(singlereport.data.title);

                if (singlereport.data.data.length > 0) {

                    const columns = Object.keys(singlereport.data.data[0]).filter(key => key !== 'color');
                    const headerFormatted = columns.map(key => getHeaderColNames(key));



                    reportJson.sheets[index].data.push({
                        backgroundColor: "#0043a9",
                        fontColor: "#FFFFFF",
                        fontSize: 13,
                        bold: true,
                        values: headerFormatted
                    });

                    const backgroundColors = excelColorCodes;

                    singlereport.data.data.forEach(item => {
                        const row = {
                            backgroundColor: backgroundColors[item.color] || "",
                            fontColor: item.color === 2 ? "#333333" : "#333333",
                            fontSize: 12,
                            bold: false,
                            values: columns.map(col => item[col])
                        };
                        reportJson.sheets[index].data.push(row);
                    });

                } else {

                    const columns = ['NoData'];
                    const item = { "NoData": "No Data" }
                    const headerFormatted = ["No Data"];
                    reportJson.sheets[index].data.push({
                        backgroundColor: "#0043a9",
                        fontColor: "#FFFFFF",
                        fontSize: 13,
                        bold: true,
                        values: headerFormatted
                    });
                    const row = {
                        backgroundColor: "",
                        fontColor: "#333333",
                        fontSize: 12,
                        bold: false,
                        values: columns.map(col => item[col])
                    };
                    reportJson.sheets[index].data.push(row);

                }



            });




            generateExcel(reportJson, 40, 20, 0, 3, multiReportTitle).catch(console.error);

            setReportDataReady(false);
            setMultiSheetDownloadStart(false);
            setReportGenerationCompleted(false);
        }
    }, [reportDataReady]);

    const loadHQList = async (year, div, branch) => {
        setHQLoading(true);
        const hqAPIResponse = await proxy(`/api/mis/hqlist/${year}/${div}/${branch}`, {}, "get");
        if (hqAPIResponse.data.length > 0) {
            setSelectedHQ(hqAPIResponse.data[0].value);
        } else {
            setSelectedHQ(0);
        }
        setHQValues(hqAPIResponse);
        setHQLoading(false);



    }


    const generateProductReport = async (productCode) => {

        const payload = {
            "myear": parseInt(SelectedYear),
            "div_code": parseInt(SelectedDiv),
            "depo_code": parseInt(SelectedDepo),
            "smon": parseInt(SelectedStartMonth),
            "emon": parseInt(SelectedEndMonth),
            "code": parseInt(productCode),
            "credit_note_type": parseInt(creditNoteType),
            "rep_type_pgwise": parseInt(GroupwiseProductWiseOpt)

        }

        var reportAPIResponse = {};
        reportAPIResponse = await proxy(`/api/mis/stkrepo9`, payload, "get");
        var processedReportData = [];
        if (reportAPIResponse == '') {
            processedReportData = { title: "NO DATA FOR " + productCode, data: [{ "NODATA": "0" }] };
        } else {
            processedReportData = hst03_report_json_format(reportAPIResponse);
        }

        const newProductReport = { "product_code": productCode, "data": processedReportData };
        setProductReportdata((productReportData) => {
            const index = productReportData.findIndex(p => p.product_code === newProductReport.product_code);
            if (index > -1) {
                return productReportData.map((p, i) => i === index ? newProductReport : p);
            } else {
                // Product doesn't exist, add it
                return [...productReportData, newProductReport];
            }
        });

        setTabLoader([...tabLoader, productCode]);
    }


    const handleExportSheetHQ = async () => {
    
            var reportJson = {};
            reportJson.fileName = reportGenData.title + ".xlsx";
            reportJson.title = reportGenData.title;
            var decimal_indexes = [];
            reportJson.author = "Aristo Pharma";
    
            reportJson.sheets = [
                {
                    name: "Sheet 1",
                    data: []
                }
            ]
    
            const columns = Object.keys(reportGenData.data[0]).filter(key => key !== 'color');
            const headerFormatted = columns.map(key => getHeaderColNames(key));
    
            reportJson.sheets[0].data.push({
                backgroundColor: "#0043a9",
                fontColor: "#FFFFFF",
                fontSize: 13,
                bold: true,
                values: headerFormatted
            });
    
            const backgroundColors = excelColorCodes;
    
            reportGenData.data.forEach(item => {
                const row = {
                    backgroundColor: backgroundColors[item.color] || "",
                    fontColor: item.color === 2 ? "#333333" : "#333333",
                    fontSize: 12,
                    bold: false,
                    //  values: columns.map(col => item[col])
                    values: columns.map((col, colIndex) => {
                        let value = item[col];
    
                        if (Array.isArray(reportGenData.decimal_keys) && reportGenData.decimal_keys.length > 0) {
                            if (reportGenData.decimal_keys.includes(col)) {
                                if (!decimal_indexes.includes(colIndex)) {
                                    decimal_indexes.push(colIndex);
                                }
                            }
                        }
    
                        return value;
                    })
                };
                reportJson.sheets[0].data.push(row);
            });
    
            generateExcel(reportJson,20,40,0,3,[],decimal_indexes).catch(console.error);
    
        }

    const handleExportSheet = async () => {

        setMultiSheetDownloadStart(true);

        if (SelectedProductCodes.length != productReportData.length) {
            await Promise.all(
                SelectedProductCodes.map(singleprod => {

                    return generateStockistReport(singleprod.value);
                })
            );
            setReportGenerationCompleted(true);
        } else {
            setReportGenerationCompleted(true);
        }
    }



    const handleTabChange = (stockistCode) => {

        if (!tabLoader.includes(stockistCode)) {

            generateStockistReport(stockistCode);
        } else {
        }
    }


    const handleReportGenHQ = async () => {
        setShowProcessLoader(true);
        document.getElementById('btnReportGen').innerHTML = "PROCESSING...";
       // goFullScreen();

        const payload = {
            "myear": parseInt(SelectedYear),
            "div_code": parseInt(SelectedDiv),
            "depo_code": parseInt(SelectedDepo),
            "smon": parseInt(SelectedStartMonth),
            "emon": parseInt(SelectedEndMonth),
            "stk_code": "",
            "rep_type": parseInt(ReportType),
            "uv": parseInt(unitValue),
            "credit_note_type": parseInt(creditNoteType),
            "rep_type_pgwise": parseInt(GroupwiseProductWiseOpt),
            "hq_code": parseInt(SelectedHQ),
            "opt_type": parseInt(optType)

        }

        var reportAPIResponse = {};
        reportAPIResponse = await proxy(`/api/mis/stkrepo2`, payload, "get");
        var processedReportData = hst03_report_json_format(reportAPIResponse);
        console.log("processedReportData", processedReportData);
console.log("processedReportData.data", processedReportData?.data);
        setreportGenData(processedReportData);
        console.log(processedReportData);
        setShowProcessLoader(false);
     

    }

    const generateStockistReport = async (stockistCode) => {

        const payload = {
            "myear": parseInt(SelectedYear),
            "div_code": parseInt(SelectedDiv),
            "depo_code": parseInt(SelectedDepo),
            "smon": parseInt(SelectedStartMonth),
            "emon": parseInt(SelectedEndMonth),
            "stk_code": (stockistCode),
            "rep_type": parseInt(ReportType),
            "uv": parseInt(unitValue),
            "credit_note_type": parseInt(creditNoteType),
            "rep_type_pgwise": parseInt(GroupwiseProductWiseOpt),
            "hq_code": parseInt(SelectedHQ),
            "opt_type": parseInt(optType)
        }

        var reportAPIResponse = {};
        reportAPIResponse = await proxy(`/api/mis/stkrepo2`, payload, "get");



        var processedReportData = [];

        if (reportAPIResponse == '') {
            processedReportData = { title: "NO DATA", data: [] };
        } else {
            processedReportData = hst03_report_json_format(reportAPIResponse);
        }


        const newProductReport = { "product_code": stockistCode, "data": processedReportData };

        setProductReportdata((productReportData) => {
            const index = productReportData.findIndex(p => p.product_code === newProductReport.product_code);
            if (index > -1) {
                return productReportData.map((p, i) => i === index ? newProductReport : p);
            } else {
                return [...productReportData, newProductReport];
            }
        });


        setTabLoader([...tabLoader, stockistCode]);


    }



    const [dataItems, setNewDataItems] = useState([]);

    function convertStockistData(dataAPIResponse) {
        if (dataAPIResponse && Array.isArray(dataAPIResponse.data)) {
            const converted_list = dataAPIResponse.data.map(item => ({
                value: item['code'],
                label: item['name']
            }));
            return converted_list;
        }
        return [];
    }

    const handleProductChange = (selectedProducts) => {

        if (selectedProducts.length > 5) {
            alert('Maximum of 5 Stockiest can be selected at a time. Please remove extra products.');
        } else {
            setSelectedProductCodes(selectedProducts);
        }


    }




    const loadStockistlist = async (division, year, depo) => {
        setProductlistLoading(true);
        const payload = {};
        const dataAPIResponse = await proxy(`/api/mis/stklist/${year}/${division}/${depo}`, payload, "get", true);
        const converted_list = convertStockistData(dataAPIResponse);
        setStockistListItems(converted_list);
        setProductlistLoading(false);
    }


    function getTabreport(pcode) {
        const index = productReportData.findIndex(item => item.product_code === pcode);
        return productReportData[index].data;
    }
    const handleReportGen = () => {
        setShowReportLoader(true);
        document.getElementById('btnReportGen').innerHTML = "PROCESSING...";
       // goFullScreen();

        if (optType == 2) {
            if (SelectedProductCodes.length == 0) {
                alert('Select aleast one product');
                return;
            } else {
                generateStockistReport(SelectedProductCodes[0].value);
            }


        } else {
            handleReportGenHQ();
        }

        setShowOptions(false);

    }

    const handleBranchChange = async (newValue) => {
        setSelectedDepo(newValue);
        loadStockistlist(SelectedDiv, SelectedYear, newValue);
        loadHQList(SelectedYear, SelectedDiv, newValue);
    }


    useEffect(() => {
        loadStockistlist(SelectedDiv, SelectedYear, SelectedDepo);
        transformNavDataForLabels("ST02").then(title => {
            setPageTitle(title);
        });
        loadHQList(SelectedYear, SelectedDiv, SelectedDepo);
    }, []);

    return (
        <>
            <div class="main-content">
                {showProcessLoader && <ProcessLoader />}
                {showOptions ?
                    <ReportOptions title={pageTitle} >
                        <div className="report-option-wrapper">
                            <div className="report-option-row">
                                <div className="report-option-item">
                                    <label>Division</label>
                                    <DropDownControl data={div_data.data} selectedValue={SelectedDiv} id="report_div_list" name="report_div_list" onChange={(newVal) => { setSelectedDIV(newVal); loadStockistlist(newVal, SelectedYear, SelectedDepo); }} />
                                </div>


                                <div className="report-option-item ml-20">
                                    <label className="mr-16" style={{ marginLeft: "5px" }}>Branch</label>
                                    <DropDownControl data={allIndiaTypeDepo} id="report_branch_list" name="report_branch_list"

                                        onChange={handleBranchChange}
                                    />
                                </div>

                            </div>


                            <div className="report-option-row">
                                <div className="report-option-item ">
                                    <label>Mkt&nbsp;Year</label>
                                    <DropDownControl data={year_data.data} id="report_mktyear_list" name="report_mktyear_list" onChange={(newYear) => {  setSelectedYear(newYear); loadStockistlist(SelectedDepo, newYear, SelectedDepo); }} />

                                </div>

                                <div className="report-option-item ml-20">
                                    <label>From</label>
                                    <DropDownControl data={month_data.data} id="report_startyear_list" name="report_startyear_list" selectedValue={SelectedStartMonth} onChange={(val) => { setSelectedStartMonth(val) }} />
                                </div>
                                <div className="report-option-item ml-10">
                                    <label>To</label>
                                    <DropDownControl data={month_data.data} id="report_endyear_list" name="report_endyear_list" selectedValue={SelectedEndMonth} onChange={(val) => { setSelectedEndMonth(val) }} />
                                </div>

                            </div>

                            <div className="report-option-row">
                                <div className="report-option-item">
                                    <input type="radio" class="js-switched mr-10" name="report_type" checked={(true && ReportType === 1)}
                                        onChange={(e) => { setReportType(1);; }} />
                                    <label>Gross</label>
                                </div>
                                <div className="report-option-item ml-14">
                                    <input type="radio" class="js-switched mr-10" name="report_type" checked={(true && ReportType === 2)}
                                        onChange={(e) => { setReportType(2); setCreditNoteType(0) }} />
                                    <label>Credit</label>
                                </div>

                                <div className="report-option-item ml-14">
                                    <input type="radio" class="js-switched mr-10" name="report_type" checked={(true && ReportType === 3)}
                                        onChange={(e) => { setReportType(3); }} />
                                    <label>Net</label>
                                </div>


                                <div className="report-option-item ml-14">
                                    <input type="radio" class="js-switched mr-10" name="report_type" checked={(true && ReportType === 4)}
                                        onChange={(e) => { setReportType(4); }} />
                                    <label>PI Sale</label>
                                </div>

                                {
                                    ReportType == 2 && <div className="report-option-item ml-20">
                                        <label>Credit&nbsp;Note</label>
                                        <DropDownControl data={configData.credit_note_dd} selectedValue={creditNoteType} name="creditNoteType" id="creditNoteType" onChange={(val) => { setCreditNoteType(val) }} />
                                    </div>
                                }

                            </div>


                            <div className="report-option-row">
                                <div className="report-option-item">
                                    <input type="radio" class="js-switched mr-10" name="report_uv" checked={(true && unitValue === 1)}
                                        onChange={(e) => { setUnitValue(1);; }} />
                                    <label>Unit</label>
                                </div>
                                <div className="report-option-item " style={{ marginLeft: "12px" }}>
                                    <input type="radio" class="js-switched mr-10" name="report_uv" checked={(true && unitValue === 2)}
                                        onChange={(e) => { setUnitValue(2); }} />
                                    <label>Value</label>
                                </div>

                                <div className="report-option-item ml-14" style={{ marginLeft: "6px" }}>
                                    <input type="radio" class="js-switched mr-10" name="report_uv" checked={(true && unitValue === 3)}
                                        onChange={(e) => { setUnitValue(3); }} />
                                    <label>Both</label>
                                </div>
                            </div>



                            <div className="report-option-row">
                                <div className="report-option-item">
                                    <input type="radio" class="js-switched mr-10" name="report_uv2" checked={(true && GroupwiseProductWiseOpt === 1)}
                                        onChange={(e) => { setGroupwiseProductWiseOpt(1);; }} />
                                    <label>Productwise</label>
                                </div>
                                <div className="report-option-item ml-14" style={{ marginLeft: "12px" }}>
                                    <input type="radio" class="js-switched mr-10" name="report_uv2" checked={(true && GroupwiseProductWiseOpt === 2)}
                                        onChange={(e) => { setGroupwiseProductWiseOpt(2); }} />
                                    <label>Groupwise</label>
                                </div>


                            </div>


                            <div className="report-option-row">
                                <div className="report-option-item">
                                    <input type="radio" class="js-switched mr-10" name="report_uv4" checked={(true && optType === 1)}
                                        onChange={(e) => { setOptType(1);; }} />
                                    <label>HQ wise</label>
                                </div>
                                <div className="report-option-item ml-14" style={{ marginLeft: "12px" }}>
                                    <input type="radio" class="js-switched mr-10" name="report_uv4" checked={(true && optType === 2)}
                                        onChange={(e) => { setOptType(2); }} />
                                    <label>Stockiest wise</label>
                                </div>


                            </div>


                            <div className="report-option-row">

                                {optType == 1 ?

                                    <>
                                        <div className="report-option-item">
                                            <label>HQ</label>

                                            {showHQLoading ? <BrandedLoader /> :
                                                <DropDownControl
                                                    data={HQvalues.data}
                                                    id="report_hq_list"
                                                    name="report_hq_list"
                                                    onChange={(optionValue) => { setSelectedHQ(optionValue) }}
                                                />
                                            }
                                        </div>
                                    </>
                                    :
                                    <div className="report-option-item">
                                        <label >Select&nbsp;Stockiest</label>
                                        {productlistLoading ? <BrandedLoader /> :
                                            <MultiSelectOptions
                                                itemsData={StockistListItems}
                                                onChange={handleProductChange}
                                            />}

                                    </div>

                                }
                            </div>



                            <div className="report-option-action-row">

                                {showReportLoader && <div style={{ marginRight: "auto" }}><ButtonLoader /></div>}
                                <button onClick={(e) => { navigate('/dashboard'); }} className="btn btn-outline btn-md btn-sec mr-10 fw-500">BACK</button>
                                <button onClick={handleReportGen} className="btn btn-md btn-primary pr-30 pl-30 fw-500 " id="btnReportGen" >SUBMIT</button>
                            </div>

                        </div>
                    </ReportOptions>
                    :
                    <>
                        <div className="row">
                            <div className="col-12">
                                <div className="card report-card" style={{ width: "auto" }}>
                                    <div className="card-title report-card-title">{'Selective Stockiest Product Wise Gross/Credit/Net Trend'}
                                        <button className="btn btn-outline btn-md  mr-10 fw-500" onClick={(e) => { window.location.reload() }}>BACK</button>
                                    </div>
                                    {optType == 1 ? <>

                                       
                                        <div className="card-body">
  {reportGenData?.data?.length > 0 && (
    <DynamicDTFloat
      tableData={reportGenData}
      firstColWidth="220px"
      secColWidth="100px"
      handleExportSheet={handleExportSheetHQ}
      fixedColumns={true}
      forceDecimal={reportGenData?.decimal_keys?.length > 0}
      decimalKeys={reportGenData?.decimal_keys}
    />
  )}
</div>



                                    </> : <>
                                        <div className="card-body card-body-multireport">


                                            <ul class="nav nav-tabs nav-tabs-light-mode nav-justified" role="tablist">

                                                {SelectedProductCodes.map((product, index) => (

                                                    <li key={product.value} class="nav-item ">
                                                        <a class={`nav-link ${index == 0 && 'active'}`} onClick={() => { handleTabChange(product.value) }} data-toggle="tab" href={`#tab${product.value}`} role="tab">{product.label}</a>
                                                    </li>

                                                ))}

                                            </ul>





                                            <div class="tab-content">
                                                {SelectedProductCodes.map((product, index) => (

                                                    <div key={product.value} className={`tab-pane fade ${index == 0 && 'active show'}`} id={`tab${product.value}`}>

                                                        {
                                                            tabLoader.includes(product.value) ?

                                                                <>
                                                                    <h3 className="fs-16 fw-500">{getTabreport(product.value).title}</h3>

                                                                    {getTabreport(product.value).data.length > 0 ? <DynamicDTFloatTabs
                                                                        fixedColumns={true}
                                                                        tableData={getTabreport(product.value)}
                                                                        tableID={`tabledt_${product.value}`}
                                                                        firstColWidth="220px"
                                                                        secColWidth="auto"
                                                                        handleExportSheet={handleExportSheet}
                                                                        forceDecimal={reportGenData.decimal_keys?.length > 0}
                                                                        decimalKeys={reportGenData.decimal_keys}

                                                                    /> : <p className="alert alert-secondary" role="alert">No data for this product.</p>}

                                                                </>
                                                                : <BrandedLoader />
                                                        }


                                                    </div>
                                                ))}


                                            </div>



                                        </div>
                                    </>}
                                    <div className="card-footer">


                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }

                {MultiSheetDownloadStart && <MultiSheetProcessingLoader title="Please wait while we download the excel file." />}
            </div>
        </>

    );
}

export default ST02;


